<template>
  <v-dialog
    :value="show"
    persistent
    max-width="424"
    @update:returnValue="handleClose">
    <v-card class="confirm-dialog-container">
      <div class="cofirm-dialog-img-wrapper">
        <img src="@/assets/images/mobile_notification.svg" >
      </div>

      <h2
        class="text-xs-center headline font-weight--medium czn-black--text text--black-87"
      >
        {{ $t('dialog.mobileNotification.title') }}
      </h2>

      <p
        class="mobile-notification-dialog__description subheading czn-black--text text--black-54 text-xs-center"
      >
        {{ $t('dialog.mobileNotification.content') }}
        <br >
        <br >
        {{ $t('dialog.mobileNotification.remark') }}
        <br >service@conzian.com
      </p>

      <div class="confirm-dialog-footer">
        <v-btn
          depressed
          color="primary"
          block
          class="confirm-dialog-footer__btn ma-0"
          @click="handleClose">
          {{ $t('dialog.mobileSimpleNotification.action') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MobileNotification',
  props: {
    show: {
      type: Boolean,
      required: true,
      default () {
        return false
      }
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.stopScroll()
      } else {
        this.recoverScroll()
      }
    }
  },
  methods: {
    handleClose () {
      this.$store.commit('system/CLOSE_MOBILE_NOTIFICATION')
    },
    // 解決遮罩層滾動穿透問題，分別在遮罩層彈出後和關閉前調用
    stopScroll () {
      const top = document.body.scrollTop || document.documentElement.scrollTop
      document.body.style.position = 'fixed'
      document.body.style.top = `${-top}px`
    },
    recoverScroll () {
      const top = -parseInt(document.body.style.top)
      document.body.style.position = 'static'
      document.body.style.top = 0
      window.scrollTo(0, top)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/settings/_screen.scss';

.confirm-dialog-container {
  padding: 24px;
}

.cofirm-dialog-img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.confirm-dialog-description {
  margin-bottom: 16px;
}

.confirm-dialog-footer {
  display: flex;
  justify-content: flex-end;

  & .confirm-dialog-footer__btn {
    min-width: 72px;
  }
}
/* .mobile-notification-dialog {
  position: fixed;
  top: 0;
  left: 0;
  // For Edge
  height: 100%;
  // WebKit-based browsers will ignore this
  height: -moz-available;
  // Mozilla-based browsers will ignore this.
  height: -webkit-fill-available;
  // For WebKit-based browsers, Edge not support this
  height: fill-available;
  width: 100vw;
  z-index: 300;

  & .card {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    max-width: 400px;
    min-width: 343px;
    max-height: 500px;
    overflow-y: auto;
    border-radius: 4px;
    z-index: 10;
  }

  @include phone-width () {
    & .card {
      max-width: 85vw;
    }
  }

  &__description {
    margin-top: 16px;
    margin-bottom: 40px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/MobileNotification.vue